import Loadable from "react-loadable";
import LoadingComponent from "../../commons/loader";

export default [
  {
    path:
      "/dashboard/brands/:brand/projects/:projectId/buildings/:building/units/:unitId/:unitName/reservation",
    exact: true,
    authL: true,
    component: Loadable({
      loader: () => import("./pages/index"),
      loading: LoadingComponent
    })
  },
  {
    path: "/dashboard/reservation/rbank/process",
    exact: true,
    authL: true,
    component: Loadable({
      loader: () => import("./pages/components/RbankSuccess/index"),
      loading: LoadingComponent
    })
  },
  {
    path: "/dashboard/reservation/paymaya/process",
    exact: true,
    authL: true,
    component: Loadable({
      loader: () => import("./pages/components/PaymayaSuccess/index"),
      loading: LoadingComponent
    })
  }
];
